interface ImageType {
  id: number;
  src: string;
  caption: string;
  heading?: string;
  subheading?: string;
}

export const galleryImages: ImageType[] = [
  // Exterior views
  {
    id: 11,
    src: '/gallery/founders-house-of-hope-main-entry-way.webp',
    caption: 'Founders House of Hope main entry way',
  },
  {
    id: 12,
    src: '/gallery/front-view-of-founders-house-of-hope.webp',
    caption: 'Front view of Founders House of Hope',
  },
  {
    id: 13,
    src: '/gallery/street-view-of-founders-house-of-hope.webp',
    caption: 'Street view of Founders House of Hope',
  },

  // Entrance and lobby areas
  {
    id: 14,
    src: '/gallery/main-entrance-lobby.webp',
    caption: 'Main entrance lobby',
  },
  {
    id: 15,
    src: '/gallery/main-entrance--front-reception-area.webp',
    caption: 'Main entrance front reception area',
  },
  {
    id: 16,
    src: '/gallery/main-entrance-reception-area.webp',
    caption: 'Main entrance reception area',
  },
  {
    id: 17,
    src: '/gallery/main-entrance-hallway.webp',
    caption: 'Main entrance hallway',
  },
  {
    id: 18,
    src: '/gallery/entrance-to-main-hallway-from-lobby.webp',
    caption: 'Entrance to main hallway from lobby',
  },
  {
    id: 19,
    src: '/gallery/main-entry-way.webp',
    caption: 'Main entry way with kitchen area',
  },

  // Dining areas
  {
    id: 20,
    src: '/gallery/dining-hall.webp',
    caption: 'Dining area at Founders House',
  },
  {
    id: 21,
    src: '/gallery/dining-hall-1.webp',
    caption: 'Large dining room with tables and chairs',
  },
  {
    id: 22,
    src: '/gallery/dining-hall-2.webp',
    caption: 'Dining hall with classroom-style seating',
  },

  // Recreation areas
  {
    id: 23,
    src: '/gallery/pool-table-room-1.webp',
    caption: 'Recreation room with pool table',
  },
  {
    id: 24,
    src: '/gallery/pool-table-room-2.webp',
    caption: 'Pool table recreation area',
  },
  {
    id: 25,
    src: '/gallery/resident-activity-room.webp',
    caption: 'Resident activity room',
  },
  {
    id: 26,
    src: '/gallery/basketball-court.webp',
    caption: 'Outdoor basketball court',
  },

  // Outdoor spaces
  {
    id: 27,
    src: '/gallery/courtyard.webp',
    caption: 'Peaceful courtyard with plants and trees',
  },
  {
    id: 28,
    src: '/gallery/courtyard-equipped-with-flower-beds-and-seating.webp',
    caption: 'Courtyard equipped with flower beds and seating',
  },
  {
    id: 29,
    src: '/gallery/courtyard-equipped-with-lounge-style-seating.webp',
    caption: 'Courtyard equipped with lounge-style seating',
  },
  {
    id: 30,
    src: '/gallery/sensory-garden.webp',
    caption: 'Therapeutic sensory garden',
  },

  // Bedrooms
  {
    id: 31,
    src: '/gallery/a-room-with-two-beds-and-a-nightstand.webp',
    caption: 'Shared room with two beds and nightstand',
  },
  {
    id: 32,
    src: '/gallery/shared-room-with-night-stand-and-restroom-1.webp',
    caption: 'Shared room with night stand and restroom',
  },
  {
    id: 33,
    src: '/gallery/shared-room-with-night-stand-and-restroom-2.webp',
    caption: 'Shared bedroom with ceiling fan',
  },
];
